import React, { useEffect, useState } from "react";

const BaseModalAnimated = ({ modal, setModal, children }) => {
    const [isRendered, setIsRendered] = useState(false);

    useEffect(() => {
        if (modal.show) setIsRendered(true);
    }, [modal.show]);

    const handleClose = () => {
        setIsRendered(false);
        setTimeout(() => setModal({ ...modal, show: false, id: null }), 300);
    };

    if (!modal.show) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4">
            {/* Backdrop con Blur */}
            <div
                className={`absolute inset-0 bg-cs-dark/40 backdrop-blur-sm transition-opacity duration-300 ${isRendered ? 'opacity-100' : 'opacity-0'}`}
                onClick={handleClose}
            />

            {/* Modal Card */}
            <div className={`
                relative w-full max-w-2xl bg-white
                rounded-t-3xl sm:rounded-3xl shadow-soft
                transform transition-all duration-300 ease-out
                ${isRendered ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-10 opacity-0 scale-95'}
                overflow-hidden mb-safe sm:mb-0
            `}>
                {/* Handle para móvil (visual) */}
                <div className="w-12 h-1.5 bg-gray-200 rounded-full mx-auto mt-3 sm:hidden" />

                <div className="p-1">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default BaseModalAnimated;